var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"btn-imprimir",attrs:{"icon":"","loading":_vm.loading},on:{"click":_vm.imprimir}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"size":"18","color":"rgba(255,255,255,0.7)"}},[_vm._v("mdi-printer-outline")])],1)]}}])},[_c('span',[_vm._v("Imprimir")])])}
var staticRenderFns = []

export { render, staticRenderFns }